import { createElement } from './helpers'

let pixelScript = null
let ugLayer = null

export function init() {
  const pixel = createElement('script', {
    type: 'text/javascript',
    async: true,
    src: 'https://app.userguest.com/ugx.js?key=RMT1QH8B5I',
  })

  pixelScript = document.head.appendChild(pixel)
}

export function confirmation(cart, property, bookingId) {
  const { checkIn, checkOut, los, items } = cart
  const { currency } = property
  const item = items[0]

  const layer = createElement('script', {
    type: 'text/javascript',
    innerHTML: `window.ugLayer = {
      event: 'conversion',
      conversionData: {
            sd: '${checkIn}',
            ed: '${checkOut}',
            rcnt: ${item.qty},
            rm: '${item.roomType}',
            nb: ${los},
            prc: ${item.price.gross},
            cur: '${currency}',
            cid: ${bookingId},
        }
    };`,
  })

  ugLayer = document.head.appendChild(layer)
  init()
}

export function terminate() {
  if (ugLayer) {
    document.head.removeChild(ugLayer)
    ugLayer = null
  }

  if (pixelScript) {
    document.head.removeChild(pixelScript)
    pixelScript = null
  }
}
